// Available permissions constants
export const AVAILABLE_PERMISSIONS = {
  "lien waiver": "Lien Waiver Access",
  "vendors": "Vendors Access",
  "integrations": "Integrations Access",
};

// Default permissions structure
export const DEFAULT_PERMISSIONS = {
  "lien waiver": false,
  "vendors": false,
  "integrations": false,
};
